import type { U2000CriteriaStaticOption } from '../../u2000Core/components/tables/basic/U2000BasicTableList';
import { u3139FormatLegacyWorkNatureDisplay } from '../U3139Service';
import concordanceLines from '../data/legacyWorkNatureConcordance.json';

export interface U3139LegacyWorkNatureConcordanceLine {
  legacyCode: string;
  legacyLabelFr: string;
}

const CONCORDANCE: U3139LegacyWorkNatureConcordanceLine[] = (
  concordanceLines as U3139LegacyWorkNatureConcordanceLine[]
).filter((line) => line.legacyCode?.trim());

/** Options critère `legacyWorkNatureCode` — libellé « description (code) », valeur = code legacy. BL-0694 */
export function buildU3139LegacyWorkNatureCriteriaOptions(
  overrideLines?: U3139LegacyWorkNatureConcordanceLine[],
): U2000CriteriaStaticOption[] {
  const lines = overrideLines?.length ? overrideLines : CONCORDANCE;
  return [...lines]
    .sort((a, b) => {
      const labelA = u3139FormatLegacyWorkNatureDisplay(a.legacyLabelFr, a.legacyCode);
      const labelB = u3139FormatLegacyWorkNatureDisplay(b.legacyLabelFr, b.legacyCode);
      const cmp = labelA.localeCompare(labelB, 'fr', { sensitivity: 'base' });
      if (cmp !== 0) return cmp;
      return a.legacyCode.localeCompare(b.legacyCode, 'fr', { sensitivity: 'base' });
    })
    .map((line) => ({
      value: line.legacyCode,
      label: u3139FormatLegacyWorkNatureDisplay(line.legacyLabelFr, line.legacyCode),
    }));
}
